import { render } from "./index.vue?vue&type=template&id=c9255a56&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c9255a56&lang=less&scoped=true"

import exportComponent from "C:\\work\\takeda\\ui\\takeda_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9255a56"],['__file',"src/layout/module/content/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9255a56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9255a56', __exports__)) {
    console.log('reload')
    api.reload('c9255a56', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c9255a56&scoped=true", () => {
    console.log('re-render')
    api.rerender('c9255a56', render)
  })

}


export default __exports__